import { Stack } from '@mui/material';
import { FlowAuthorizationStatusDetailsRequirement } from 'flow-schema';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSwitchField } from '../../../ConfigFields/Switch';

export function SubmitPriorAuthorizationFormFields() {
  return (
    <Stack gap={4}>
      <BlockSwitchField
        fieldName="config.authorizationStatusDetailsRequirement"
        label="Require authorization status details"
        helperText="When off, analysts can complete the authorization status details step without filling out fields like dates, tracking number, and verification file uploads. The authorization status is always required."
        toggleStates={{
          activeState: FlowAuthorizationStatusDetailsRequirement.Required,
          inactiveState: FlowAuthorizationStatusDetailsRequirement.Optional,
        }}
      />
      <BlockValueTemplateField
        fieldName="config.priorAuthorizationInformation.patientOrderId"
        label="Patient Order Id"
        helperText="Enter the form template for the patientOrderId. Template must have matching braces. e.g. {{blockName.data}}"
      />
      <BlockValueTemplateField
        fieldName="config.priorAuthorizationInformation.renderingFacility"
        label="Rendering Facility"
        helperText="Enter the form template for the renderingFacility data. Template must have matching braces. e.g. {{blockName.data}}"
      />
      <BlockValueTemplateField
        fieldName="config.priorAuthorizationInformation.contactInformation"
        label="Contact Information"
        helperText="Enter the form template for the contactInformation data. Template must have matching braces. e.g. {{blockName.data}}"
      />
    </Stack>
  );
}
